import {
	Column,
	Accordion,
	AccordionTab,
	Button,
	OverlayPanel,
	DataTable,
	InputNumber,
	Dialog,
	AutoComplete,
	Toast,
	Dropdown,
	Divider,
	Card,
} from "../components/crud";
import { MaterialCapitulo } from "../pages/crud/MaterialCapitulo";

// import { Divider } from 'primereact/divider';
// import { TablaDatos } from "../crud/tabla/TablaDatos";
// import {
// 	codeBodyTemplate,
// 	productDialogFooter,
// } from "../../components/crud/tabla/Funciones";

// import { Conexion } from "../../service/Conexion";
// import { BarraSuperior } from "../crud/tabla/BarraSuperior";
// import { Capitulo } from "../../pages/crud/Capitulo";
// import { MaterialCapitulo } from "../../pages/crud/MaterialCapitulo";

export const CapituloBom = ({
	capitulo,
	listaMateriales,
	listaPlantillas,
	tableDropdownCapitulos,
	controlcambios,
	setcontrolcambios,
}) => {
	const {
		cod_bom_cbo: codigoBom,
		cod_cbo: codigoCapitulo,
		nom_cap: tipo,
		can_cbo: cantidad,
		nom_cbo: nombre,
		totalcapitulo: totalcapitulo,
	} = capitulo;
	// console.log(capitulo);
	// const [datostabla, setdatostabla] = useState(null);
	// const op = useRef(null);
	// let emptyProduct = {
	// 	id: null,
	// 	codigoCapitulo: codigoCapitulo,
	// 	codigomaterial: 0,
	// 	cantidad: 0,
	// 	precio: 0,
	// 	codigoBom: codigoBom,
	// 	codigoPlantilla: 0,
	// };
	// const toast = useRef(null);
	// const TABLA = "cuerpobomdetalle ";
	// const [product, setProduct] = useState(emptyProduct);
	// const [deleteProductDialog, setDeleteProductDialog] = useState(false);
	// const [productDialog, setProductDialog] = useState(false);
	// const datatable = new Conexion();
	// const [submitted, setSubmitted] = useState(false);

	// const [cantidadMaterial, setcantidadMaterial] = useState(0);

	// const confirmDeleteProduct = (product) => {
	// 	setProduct(product);
	// 	setDeleteProductDialog(true);
	// };

	// const hideDialog = () => {
	// 	setSubmitted(false);
	// 	setProductDialog(false);
	// };

	// const saveProduct = () => {
	// 	setSubmitted(true);
	//     console.log(product)

	// 	let resultado = "";
	// 	// let _products = [...datostabla];
	// 	let _product = { ...product };
	//     // return false;
	// 	console.log(_product);
	// 	// return false;
	// 	if (product.codigomaterial > 0 || product.codigoPlantilla > 0) {
	// 		if (product.id == null) {
	//             console.log({TABLA})
	// 			resultado = datatable.getCrearItem(TABLA, product);
	// 			// debugger
	//             // _products = [...datostabla];
	// 			// _product = { ...product };
	// 			// _products.push(_product);
	// 			// setdatostabla(_products);
	// 		} else {
	// 			// resultado = datatable.getEditarItem(TABLA, product, product.id);
	// 			// const index = findIndexById(product.id, datostabla);
	// 			// _products[index] = _product;
	// 		}
	// 		resultado.then((value) => {
	// 			toast.current.show({
	// 				severity: "success",
	// 				summary: "Confirmacion",
	// 				detail: "Transacción Exitosa",
	// 				life: 4000,
	// 			});
	// 			setProductDialog(false);
	// 			setProduct(emptyProduct);

	// 		});
	// 	}
	// };

	// const openNew = () => {
	// 	setProduct(emptyProduct);
	// 	setSubmitted(false);
	// 	setProductDialog(true);
	// };

	return (
		<>
			<Accordion multiple className='accordion-custom' activeIndex={0}>
				<AccordionTab
					header={
						<>
							<i className='pi pi-book'></i>
							<span
								className='ml-2'
								style={{
									fontSize: "1.1rem",
									fontWeight: "700",
								}}>
								{tipo} - {nombre}
							</span>
						</>
					}>
					{/* <Capitulo
						capitulo={capitulo}
						tableDropdownCapitulos={tableDropdownCapitulos}
						controlcambios={controlcambios}
						setcontrolcambios={setcontrolcambios}
						totalcapitulo={totalcapitulo}
					/> */}
					<Divider align='left'>
						<div className='p-d-inline-flex p-ai-center '>
							<i className='pi pi-tags p-mr-2'></i>
							<b className='pl-4'>Lista de Materiales</b>
						</div>
					</Divider>
					{/* <pre>{JSON.stringify(capitulo)}</pre> */}

					<MaterialCapitulo
						capitulo={capitulo}
						listaMateriales={listaMateriales}
						listaPlantillas={listaPlantillas}
					/>
					<br />
					<br />
				</AccordionTab>
			</Accordion>
		</>
	);
};
